import React, { useState } from 'react';

import { Icon, Text } from '@betterment/samba-react';
import { Box, Button, Flex } from '@betterment/style-closet-react';

import LockedAccountModal from './LockedAccountModal';

import Card from '../../Shared/components/Card';

const LockedManageAccount: React.FC<React.PropsWithChildren<unknown>> = () => {
  const [shouldShowLockedModal, setShowLockedModal] = useState(false);
  const closeHandler = () => {
    setShowLockedModal(false);
  };
  return (
    <Box mb="6">
      <Card>
        <Card.Slot name="header">
          <Text
            as="p"
            css={{
              fontSize: 'fontSize.200',
              fontWeight: 'medium',
              margin: 'space.0',
            }}
          >
            Manage account
          </Text>
        </Card.Slot>
        <Card.Slot name="body">
          <Flex flexDirection="column">
            <Flex justifyContent="center">
              <Icon name="Lock" size="small" color="icon.critical" />
            </Flex>
            <Flex>
              <Text
                as="p"
                css={{
                  textAlign: 'center',
                  paddingY: 'space.200',
                  marginBottom: 'space.200',
                  _last: { marginBottom: 'space.0' },
                }}
              >
                You won't be able to take action on your Checking account until we unlock it.
              </Text>
            </Flex>
            <Button variant="tertiary" onClick={() => setShowLockedModal(true)}>
              Learn more
            </Button>
          </Flex>
        </Card.Slot>
      </Card>
      {shouldShowLockedModal && <LockedAccountModal closeHandler={closeHandler} />}
    </Box>
  );
};

export default LockedManageAccount;
